import { render, staticRenderFns } from "./ChoferForm.vue?vue&type=template&id=21607944"
import script from "./ChoferForm.vue?vue&type=script&lang=js"
export * from "./ChoferForm.vue?vue&type=script&lang=js"
import style0 from "./ChoferForm.vue?vue&type=style&index=0&id=21607944&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports